/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupVehicleGroupAssignmentCreate
 */
export interface UserGroupVehicleGroupAssignmentCreate {
    /**
     * 
     * @type {string}
     * @memberof UserGroupVehicleGroupAssignmentCreate
     */
    userGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupVehicleGroupAssignmentCreate
     */
    vehicleGroupId: string;
}

/**
 * Check if a given object implements the UserGroupVehicleGroupAssignmentCreate interface.
 */
export function instanceOfUserGroupVehicleGroupAssignmentCreate(value: object): value is UserGroupVehicleGroupAssignmentCreate {
    if (!('userGroupId' in value) || value['userGroupId'] === undefined) return false;
    if (!('vehicleGroupId' in value) || value['vehicleGroupId'] === undefined) return false;
    return true;
}

export function UserGroupVehicleGroupAssignmentCreateFromJSON(json: any): UserGroupVehicleGroupAssignmentCreate {
    return UserGroupVehicleGroupAssignmentCreateFromJSONTyped(json, false);
}

export function UserGroupVehicleGroupAssignmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupVehicleGroupAssignmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'userGroupId': json['userGroupId'],
        'vehicleGroupId': json['vehicleGroupId'],
    };
}

export function UserGroupVehicleGroupAssignmentCreateToJSON(json: any): UserGroupVehicleGroupAssignmentCreate {
    return UserGroupVehicleGroupAssignmentCreateToJSONTyped(json, false);
}

export function UserGroupVehicleGroupAssignmentCreateToJSONTyped(value?: UserGroupVehicleGroupAssignmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userGroupId': value['userGroupId'],
        'vehicleGroupId': value['vehicleGroupId'],
    };
}

